export const getUserHomeInfoApiHandler = {
  method: "GET",
  path: () => `users-repository/test`
};